import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Avatar, Button, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Component } from 'react';
import { numberFormatterInternational } from '../../../../../app/utils/telephonyHelpers';
import styles from './index.module.scss';
export default class UserItem extends Component {
    constructor(props) {
        super(props);
        this.resolveAddActionTooltip = this.resolveAddActionTooltip.bind(this);
        this.resolveName = this.resolveName.bind(this);
        this.isUserProfile = this.isUserProfile.bind(this);
        this.isUserAuthor = this.isUserAuthor.bind(this);
        this.areActionsDisabled = this.areActionsDisabled.bind(this);
        this.renderAvatar = this.renderAvatar.bind(this);
        this.renderDetails = this.renderDetails.bind(this);
        this.renderAddAction = this.renderAddAction.bind(this);
    }
    isUserAuthor() {
        const { user, metaConversation: { conversation }, } = this.props;
        return (conversation.authors &&
            Object.prototype.hasOwnProperty.call(conversation.authors, user.id));
    }
    isUserProfile() {
        const { user, profile } = this.props;
        return user.id === profile.id;
    }
    areActionsDisabled() {
        return this.isUserAuthor() || this.isUserProfile();
    }
    resolveAddActionTooltip() {
        if (this.isUserAuthor()) {
            return 'This user is already in the conversation.';
        }
        if (this.isUserProfile()) {
            return 'You cannot add yourself.';
        }
        return 'Add caller to conversation.';
    }
    renderAvatar() {
        const { user } = this.props;
        const avatar = user.icon !== undefined ? (_jsx(DixaIcon, { className: styles.phoneIcon, icon: user.icon })) : (_jsx(Avatar, { user: user }));
        return _jsx("div", Object.assign({ className: styles.avatar }, { children: avatar }));
    }
    isNameAvailable() {
        const { user } = this.props;
        return (typeof user.name !== 'string' && typeof user.display_name !== 'string');
    }
    resolveName() {
        const { user } = this.props;
        const nameField = ['name', 'display_name', 'phone_number', 'email'].find((attribute) => typeof user[attribute] === 'string' && user[attribute].length > 0);
        return nameField ? user[nameField] : 'Anonymous';
    }
    renderDetails() {
        const { user, disabled } = this.props;
        const name = this.resolveName();
        const isNumberShown = this.isNameAvailable();
        const toPhoneNumberFormat = !disabled
            ? numberFormatterInternational({ phoneNumber: user.phone_number })
            : '';
        return (_jsxs("div", Object.assign({ className: styles.details }, { children: [_jsx("span", Object.assign({ className: styles.name }, { children: name })), _jsx("span", Object.assign({ className: styles.extra }, { children: isNumberShown === false && user.phone_number !== null
                        ? toPhoneNumberFormat
                        : 'Contact' }))] })));
    }
    renderAddAction() {
        const { user, onAddCallerClick } = this.props;
        const tooltip = this.resolveAddActionTooltip();
        return (_jsx("div", Object.assign({ className: styles.addToCallButton }, { children: _jsx(Tooltip, Object.assign({ content: tooltip, wrap: "span", dark: true }, { children: _jsx(Button, Object.assign({ disabled: this.areActionsDisabled(), onClick: () => onAddCallerClick(user), variant: "secondary" }, { children: "Add" })) })) })));
    }
    render() {
        const rootClass = classnames({
            [styles.root]: true,
            [styles.rootDisabled]: this.props.disabled,
        });
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [this.renderAvatar(), this.renderDetails(), this.renderAddAction()] })));
    }
}
